module.exports = __webpack_public_path__ + "img/del-icon.1bccd7f2.svg";